module.exports = __webpack_public_path__ + "media/images/flags/1x1/aze-952f796d4fb69d98619235fb347f6e0b.svg";